











































import { Component, Prop, Vue } from "vue-property-decorator";
import FeedCard from "@/components/FeedCard.vue";
import { FeedPage } from "@/store/feed";

@Component({
  components: { FeedCard }
})
export default class FeedSection extends Vue {
  @Prop() page!: FeedPage;

  get status() {
    return this.page.data.status;
  }

  refresh() {
    this.$emit("refresh");
  }
}
